import "core-js/modules/es.array.index-of.js";
var _excluded = ["staticContext"],
    _excluded2 = ["children", "client", "imageWidth", "selection", "mirror"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { getImagePrefix } from '@anewgo/utils/dist';
import { apply, getPath, identity, pipe, propEquals, reduce, transpose } from '@anewgo/functions';
import { addParam, addPath, getUrlFromQuery, makeQuery } from './restQueryBuilder';
import { isInventoryLot } from '@anewgo/utils/dist/siteplans';
var HEMI_API_KEY = 376;

var withoutStaticContextProp = function withoutStaticContextProp(_ref) {
  var staticContext = _ref.staticContext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return Object.assign({}, rest);
};

var SelectionImage = function SelectionImage(_ref2) {
  var children = _ref2.children,
      client = _ref2.client,
      imageWidth = _ref2.imageWidth,
      selection = _ref2.selection,
      mirror = _ref2.mirror,
      imgProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var community = selection.community,
      plan = selection.plan,
      elevation = selection.elevation,
      lot = selection.lot,
      originalScheme = selection.scheme,
      colorSelections = selection.colorSelections;
  if (!plan && !elevation && !lot) return children ? children(null) : null;
  var url;
  var prefixMods = imageWidth ? "w_" + imageWidth : undefined;

  if (lot != null && lot.inventory && ((lot == null ? void 0 : lot.salesStatus) === 'INVENTORY' || (lot == null ? void 0 : lot.salesStatus) === 'UNDER_CONSTRUCTION')) {
    var _lot$inventory = lot.inventory,
        photos = _lot$inventory.photos,
        photoFolder = _lot$inventory.photoFolder; // 1. Try to get an inventory photo

    url = pipe(reduce(function (acc, photo) {
      return acc.listIndex > photo.listIndex ? photo : acc;
    }, photos[0]), getPath('src'), apply(function (src) {
      return "" + getImagePrefix(client.directoryName, "images/inventories/" + photoFolder + "/", prefixMods) + src;
    }))(photos);
  }

  if (!url && community && elevation) {
    // 2. Try the exterior configuration
    var _ref3 = getPath('inventory', 'exteriorConfiguration')(lot) || {},
        inventoryScheme = _ref3.scheme,
        inventoryPaletteElementSelections = _ref3.paletteElementSelections;

    var isInventory = apply(isInventoryLot)(lot); // Choose between the inventory's scheme and the favorite's scheme

    var scheme = isInventory ? inventoryScheme != null ? inventoryScheme : originalScheme : originalScheme; // Choose between the inventory's color selections and the favorite's color
    // selections

    var paletteElementSelections = isInventory ? inventoryPaletteElementSelections : null;

    if (!paletteElementSelections && colorSelections) {
      // Here, we'll defer to the colorSelections data, but we'll normalize it
      // to the format that we'd expect from inventoryPaletteElementSelections
      paletteElementSelections = [];
      Object.keys(colorSelections).forEach(function (elementId) {
        var _colorSelections$elem = colorSelections[elementId],
            id = _colorSelections$elem.id,
            paletteId = _colorSelections$elem.paletteId;
        paletteElementSelections.push({
          paletteId: paletteId,
          paletteSelection: {
            id: id
          },
          elementId: elementId
        });
      });
    }

    var paletteMode = paletteElementSelections && paletteElementSelections.length > 0;
    var schemeMode = scheme || inventoryScheme;

    if (paletteMode || schemeMode) {
      var _ref4 = apply(transpose(getPath('paletteId'), getPath('paletteSelection', 'id'), getPath('elementId')))(paletteElementSelections) || [],
          pals = _ref4[0],
          sels = _ref4[1],
          mats = _ref4[2];

      url = pipe(addPath('api', 'exterior', 'client', client.altName, 'nbr', community.name, 'plan', elevation.planName), addParam('elevId', elevation.id), addParam('key', HEMI_API_KEY), schemeMode && paletteMode ? addPath('hybrid') : identity, !schemeMode && paletteMode ? addPath('palette') : identity, schemeMode ? addPath('scheme', scheme.name) : identity, paletteMode ? pipe(addParam.apply(void 0, ['pals'].concat(pals)), addParam.apply(void 0, ['sels'].concat(sels)), addParam.apply(void 0, ['mats'].concat(mats))) : identity, imageWidth ? addParam('w', imageWidth) : identity, getUrlFromQuery)(makeQuery(process.env.REACT_APP_HEMI_ENGINE));
    }
  }

  if (!url) {
    if (!plan && !elevation) return children ? children(null) : null; // 3. Use an elevation thumbnail

    var sampleElevation;

    if (elevation) {
      sampleElevation = elevation;
    } else if (plan.elevations && plan.elevations.length > 0) {
      sampleElevation = plan.elevations.find(propEquals('id', plan.defaultElevationId)) || plan.elevations[0];
    } else {
      return children ? children(null) : null;
    }

    url = "" + getImagePrefix(client.directoryName, 'images/elevations/', prefixMods) + sampleElevation.thumb;
  }

  var mirrorDisplayImage = elevation && elevation.garagePosition && elevation.defaultGaragePosition && elevation.garagePosition !== elevation.defaultGaragePosition && !mirror || mirror && elevation.garagePosition === elevation.defaultGaragePosition;
  return children ? children(url) : /*#__PURE__*/React.createElement("img", _extends({
    src: url,
    style: {
      transform: mirrorDisplayImage ? 'scaleX(-1)' : null
    },
    alt: ""
  }, withoutStaticContextProp(imgProps)));
};

export default SelectionImage;